import React from 'react';
import BaseCascader from './BaseCascader';
import AreaCascader from './AreaCascader';

/**
 * 地区类型的 data_source 值集合
 */
const AREA_TYPES = ['province', 'province_city', 'province_city_district'];

/**
 * CascaderForm - 级联组件入口分发器
 *
 * 根据 setting.data_source 判断渲染哪个子组件：
 * - province / province_city / province_city_district → AreaCascader（省市区县）
 * - 其他所有类型 → BaseCascader（通用基类）
 *
 * 对外名称保持为 CascaderForm，现有引用无需修改
 */
const CascaderForm = (props) => {
    const dataSource = props.setting?.data_source;

    if (AREA_TYPES.includes(dataSource)) {
        return <AreaCascader {...props} />;   // 省市区县类型
    }

    return <BaseCascader {...props} />;        // 其他所有类型（使用默认逻辑）
};

export default CascaderForm;
